// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bYsRh_alrNIl0sTf{display:grid;grid-column-gap:4px;grid-template-columns:20px 1fr;justify-content:center;align-items:center;min-height:16px}.bYsRh_alrNIl0sTf .WhmzV0mY9TgaRD4I{width:20px;height:20px}.bYsRh_alrNIl0sTf .QHxYkn24tR8ULi_f{line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.N2NbMF_mo705yDIB{display:flex;align-items:center;justify-content:center;column-gap:8px;margin-right:8px;padding-top:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userBox": `bYsRh_alrNIl0sTf`,
	"userAvatar": `WhmzV0mY9TgaRD4I`,
	"userName": `QHxYkn24tR8ULi_f`,
	"showRedactedSwitch": `N2NbMF_mo705yDIB`
};
export default ___CSS_LOADER_EXPORT___;
